import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { VideoType } from '@/modules/common/types/video';

import { updateVideoResources } from '@/modules/common/helpers/videoCache';

type SearchQuery = {
  query?: Record<string, string | boolean | number>;
  distributionIds?: [VideoType];
  filterIds?: Array<string | number>;
  isAddRequest?: boolean;
};

type SearchState = {
  isLoading: boolean;
  totalCount: number;
  playlist: VideoType[];
  queryRequest: SearchQuery;
  playerPropsPassThrow: Record<string, unknown>;
};

const initialState: SearchState = {
  isLoading: false,
  totalCount: 0,
  playlist: [],
  queryRequest: {},
  playerPropsPassThrow: {},
};

/** https://immerjs.github.io/immer/update-patterns/ */
export const slice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    setInitialState: () => initialState,
    setSearchQueryAction: (state, action) => {
      state.queryRequest = action.payload;
    },
    searchRequestEventAction: (state) => {
      state.isLoading = true;
    },
    clearSearchResultAction: (state) => {
      state.playlist = [];
      state.totalCount = 0;
      state.playerPropsPassThrow = {};
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    searchRequestAction: (state, action: PayloadAction<SearchQuery>) => state,
    setSearchRequestAction: (state, action) => {
      state.totalCount = action.payload.totalCount;
      state.playlist = action.payload.playlist;
      state.playerPropsPassThrow = action.payload.playerPropsPassThrow;
      state.isLoading = false;
    },
    autocompleteRequestAction: (state) => state,
    errorSearchRequestAction: (state) => {
      state.isLoading = false;
    },
    updateSocialMetricAction: (state, action) => {
      state.playlist.forEach((video) => {
        if (video.mediaid === action.payload.mediaid) {
          Object.entries(action.payload.parameters).forEach(([key, value]) => {
            const item = video.performanceData.parameters.find((item$) => item$.type === key);

            if (item) {
              item.value = value as number;
            }
          });
        }
      });
    },
    updateResourceAction: (state, action) => {
      state.playlist.forEach((video) => {
        updateVideoResources(video, action.payload);
      });
    },
  },
});

export const {
  setInitialState,
  setSearchQueryAction,
  clearSearchResultAction,
  searchRequestEventAction,
  searchRequestAction,
  setSearchRequestAction,
  errorSearchRequestAction,
  updateSocialMetricAction,
  updateResourceAction,
} = slice.actions;
